<template>
    <v-container fluid>
      <reporte_cxc v-if="$store.state.emp.id_empresa == 55"/>    
      
    </v-container>
  </template>
  
  <script>
    import reporte_cxc from './Conab/reporte_cxc.vue';
  
  export default {
    data: () => ({
      //
    }),
    components: {
        reporte_cxc,
    },
  };
  </script>